import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { googleSession } from '../lib/api';
import { useAuth } from '../lib/auth';
import { Loader2, AlertTriangle } from 'lucide-react';

// Handles Google's redirect back: /auth/google?code=...
export default function GoogleCallbackPage() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [error, setError] = useState('');
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const oauthError = params.get('error');
    if (oauthError) { setError('Connexion Google annulée.'); return; }
    if (!code) { setError('Code Google manquant.'); return; }
    (async () => {
      try {
        const res = await googleSession({ code });
        login(res.data.token, res.data.user);
        window.history.replaceState(null, '', '/account');
        navigate('/account', { replace: true });
      } catch (e) {
        setError(e.response?.data?.detail || 'Connexion Google échouée.');
      }
    })();
  }, [login, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-rolex-green-deep px-4" data-testid="google-callback-page">
      <div className="text-center max-w-sm">
        {error ? (
          <>
            <AlertTriangle className="w-12 h-12 text-gold mx-auto mb-4" />
            <h1 className="font-display text-2xl font-bold text-cream mb-2">Oups…</h1>
            <p className="text-cream/70 text-sm mb-6">{error}</p>
            <button onClick={() => navigate('/')} className="px-6 py-3 rounded-xl bg-gold-gradient text-rolex-green font-bold text-sm" data-testid="google-home-btn">Retour à l'accueil</button>
          </>
        ) : (
          <>
            <Loader2 className="w-6 h-6 text-gold animate-spin mx-auto mb-3" />
            <p className="text-cream/80 text-sm">Connexion avec Google…</p>
          </>
        )}
      </div>
    </div>
  );
}
